import { useEffect, useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Wrench } from "lucide-react";
import { useAuth } from "@/context/Auth";
import { api, errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [maint, setMaint] = useState(sessionStorage.getItem("maint_msg") || "");
  useEffect(() => {
    api.get("/maintenance").then((r) => setMaint(r.data.on ? r.data.message : "")).catch(() => {});
    sessionStorage.removeItem("maint_msg");
  }, []);
  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await login(u, p);
      nav("/");
    } catch (e2) {
      setErr(errMsg(e2));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-6">
      <form onSubmit={submit} className="w-full max-w-[300px] space-y-4 rise" data-testid="login-form">
        {maint && <div data-testid="maintenance-notice" className="flex gap-2 rounded-md border border-amber-200 bg-amber-50 p-3 text-sm text-amber-800"><Wrench className="h-4 w-4 shrink-0 mt-0.5" /><span>{maint}</span></div>}
        <div className="space-y-1.5">
          <label htmlFor="u" className="text-xs font-semibold text-slate-700">Username</label>
          <Input id="u" data-testid="login-username-input" value={u} onChange={(e) => setU(e.target.value)} autoFocus placeholder="Username" className="h-10 bg-white" />
        </div>
        <div className="space-y-1.5">
          <label htmlFor="p" className="text-xs font-semibold text-slate-700">Kata sandi</label>
          <Input id="p" data-testid="login-password-input" type="password" value={p} onChange={(e) => setP(e.target.value)} placeholder="Kata sandi" className="h-10 bg-white" />
        </div>
        {err && <p data-testid="login-error" className="text-xs text-red-600">{err}</p>}
        <Button data-testid="login-submit-button" type="submit" disabled={busy || !u || !p} className="w-full h-10 bg-emerald-500 hover:bg-emerald-600 text-white font-semibold">
          {busy ? "Memeriksa…" : "Login"}
        </Button>
      </form>
    </div>
  );
}
